module.exports = __webpack_public_path__ + "img/s2-calendar.8130d0ec.png";